export default function () {
  return {
    printerGroups: []
  };
}
